import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import type { BaseContext } from '@/types';
import { ROSA_QUERY_KEYS } from './query-keys';
import type { RosaSubCategory } from './useGetRosaCategories';

type GetElementsRequest = BaseContext & {
	category_id: string;
};

export type Element = {
	id: string;
	name: string;
	score: number;
	sequence: number;
	required: boolean;
	description: string;
	sub_category: RosaSubCategory;
};

export type ElementTypes = {
	required: Element[];
	not_required: Element[];
};

export type GetElementsResponse = Record<string, ElementTypes>;

async function getElements(params: GetElementsRequest): Promise<GetElementsResponse> {
	const url = `ergonomic-tool/rosa/elements/${params.category_id}`;
	const { data } = await Api.get<GetElementsResponse>(url, { params });
	return data;
}

export const useGetElements = (params: GetElementsRequest) => {
	const data = useQuery([ROSA_QUERY_KEYS.GET_ELEMENTS, params.category_id], () => getElements(params));
	return data;
};
